
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexyW_453qDwKDdc21Y11rBvAqvKhhOeFBMdHpxBytOdTi9sMeta } from "/tmp/build_0a61a028/pages/app/me/index.vue?macro=true";
import { default as meO2RrXpyHyrhjjZEkcNsor9ms1EkprZwc4clRhkDG44oMeta } from "/tmp/build_0a61a028/pages/app/me.vue?macro=true";
import { default as mape_45QuTv0oK7CTH_85uMCjq7LuxdIIun_45_8GJlKVGzOu8Meta } from "/tmp/build_0a61a028/pages/app/map.vue?macro=true";
import { default as postf8SjGEs2kfGQXbReNpHNrFotkNCKu7A8jzx0iQbMZPAMeta } from "/tmp/build_0a61a028/pages/app/feed/post.vue?macro=true";
import { default as indexArLjz894MjfycN0BkkDluJHdcg5lAzfkionzIfMClS8Meta } from "/tmp/build_0a61a028/pages/app/feed/index.vue?macro=true";
import { default as _91type_93spOhCcl2HUIWjkMD_JFH_jxcLbJtramrLk97tg7z2iQMeta } from "/tmp/build_0a61a028/pages/app/feed/[type].vue?macro=true";
import { default as feediZgjFaybYhqmNniNegCNZESOwMZ7F125_45tHdFT8LiIAMeta } from "/tmp/build_0a61a028/pages/app/feed.vue?macro=true";
import { default as index02RcnmdFtabmC11MzSHLTzLIchMU7JYnQFY12fY_45jTkMeta } from "/tmp/build_0a61a028/pages/app/index.vue?macro=true";
import { default as eula6Plna0PMyVf1vB_45hR0_45QRp7NJxhz4iTJET_45ZHPNzfokMeta } from "/tmp/build_0a61a028/pages/main/eula.vue?macro=true";
import { default as quizh11l4Q8MY_7XLzkVYASjOuIhSku4Ghy7zuOFVwcvi74Meta } from "/tmp/build_0a61a028/pages/admin/quiz.vue?macro=true";
import { default as indexDbvW5pmgE_45JzKdwwMIstdBBalxUWEmELltgrc0hIDncMeta } from "/tmp/build_0a61a028/pages/app/groups/index.vue?macro=true";
import { default as edityvaP3CLfTj0BS9dPSKn6_0VXOibfBKm3djYLLFHHvY4Meta } from "/tmp/build_0a61a028/pages/app/groups/[slug]/edit.vue?macro=true";
import { default as aboutZfFSJauWvKiwEw5CPYTZFev8xz7r9HRmsnmLicoxsIgMeta } from "/tmp/build_0a61a028/pages/app/groups/[slug]/about.vue?macro=true";
import { default as indexis1bWNqcRjS433HYWKkImPnSG9DZlWZq3f8z8hUKdcUMeta } from "/tmp/build_0a61a028/pages/app/groups/[slug]/index.vue?macro=true";
import { default as eventssTRO_keuBXvvwL1l82bxVpiXOzsEAH6Ytumjn3SE7VAMeta } from "/tmp/build_0a61a028/pages/app/groups/[slug]/events.vue?macro=true";
import { default as members2NB_sNcuvA_jbBI6IwTsHbdRHbCyVBq2sqBFg_VWlVYMeta } from "/tmp/build_0a61a028/pages/app/groups/[slug]/members.vue?macro=true";
import { default as conversationslB1wilvCIQPbJMjk3d6KOnsTgN7HLtRW_45ykTkIVZaE4Meta } from "/tmp/build_0a61a028/pages/app/groups/[slug]/conversations.vue?macro=true";
import { default as _91slug_93hmlB1PsmJ30xMEi04FMivuMW0pQldBNTrovLO_45XUvk0Meta } from "/tmp/build_0a61a028/pages/app/groups/[slug].vue?macro=true";
import { default as creategOP6zyeOjJ_45_ZxhJLR8C9P5uGoqp4PKNBcUP91EmmT0Meta } from "/tmp/build_0a61a028/pages/app/groups/create.vue?macro=true";
import { default as groupsC_On8YvARcRUn8uUArADWx0GBA9VjwMS9EBNNorXQQYMeta } from "/tmp/build_0a61a028/pages/app/groups.vue?macro=true";
import { default as indexB_9nPvtQ74pTEBTuTftg_45d5mci_45gKqIoJi29F4KARb8Meta } from "/tmp/build_0a61a028/pages/app/params/index.vue?macro=true";
import { default as accountU3qvXnW7NU26yZy_6D4xumR7llU4f0njNDEyxvHi_BEMeta } from "/tmp/build_0a61a028/pages/app/params/account.vue?macro=true";
import { default as transactionsJyU9ImYi7K73k8U_45TEnFonda_Bpj5W8X4dODLOjMyGIMeta } from "/tmp/build_0a61a028/pages/app/params/transactions.vue?macro=true";
import { default as paramsbi5C3bUf14_aVGxg6Kh9fm8rkJ2stKs11aEAqJFQn_45YMeta } from "/tmp/build_0a61a028/pages/app/params.vue?macro=true";
import { default as indexczvp0mHpM2HTkNFCw8sojbQyUv5h0HTzDFW_TVGj9IoMeta } from "/tmp/build_0a61a028/pages/main/index.vue?macro=true";
import { default as pressme6ddzWe9BwKaPQzWW_V7vsxHCmhau7gTD2s9FHHfvoMeta } from "/tmp/build_0a61a028/pages/main/press.vue?macro=true";
import { default as codesE3PgMcRoJUxi_OCEDjzy1Qf9H9_45SiqOfq04tzed_45c0cMeta } from "/tmp/build_0a61a028/pages/admin/codes.vue?macro=true";
import { default as indexAD0yf4VOgOylDSAkBmaGp2MidmlRlXb7F_45YF9s6Nd08Meta } from "/tmp/build_0a61a028/pages/admin/index.vue?macro=true";
import { default as index3OCLeuERCJb8c4P97b3BQu7nexWedXcqJXFj5iSSYAgMeta } from "/tmp/build_0a61a028/pages/app/hangout/index.vue?macro=true";
import { default as agendaBpbhSa3MFIONcMcXBJEX7S_4551U3IiylD_jqY_kZu5SkMeta } from "/tmp/build_0a61a028/pages/app/hangout/agenda.vue?macro=true";
import { default as meetupsPsdenkHW2rQQIgZnc0thannZ02YIUqQGkIDpqCClK3gMeta } from "/tmp/build_0a61a028/pages/app/hangout/meetups.vue?macro=true";
import { default as organizepOhysMYRNwtM_45QdtvitXkFAr9aWIIs7FHvhFETihj6kMeta } from "/tmp/build_0a61a028/pages/app/hangout/organize.vue?macro=true";
import { default as hangoutdz3LpIaIKQ5e_45rdpuPyv_OCzMh3idUtSI_45JF3ooNZDMMeta } from "/tmp/build_0a61a028/pages/app/hangout.vue?macro=true";
import { default as charteXba_y2Hmmg9DTPOrKC2A8AexcEB6Cpn8O_vbjAo6R6gMeta } from "/tmp/build_0a61a028/pages/main/charte.vue?macro=true";
import { default as francecUocFvxboqrzlRq0kg0Ii9AyFlLcaybsMW278HDwp9oMeta } from "/tmp/build_0a61a028/pages/main/france.vue?macro=true";
import { default as themesVVlepjwiVhM2mtK46_45W3K_N8rWASURpsz_9_X_45PQ1XMMeta } from "/tmp/build_0a61a028/pages/admin/themes.vue?macro=true";
import { default as indexyPne2LMbdtz7_459WzCDbYe0Dbs25G2eHJg0hdqm3eQjsMeta } from "/tmp/build_0a61a028/pages/app/insiders/index.vue?macro=true";
import { default as suggestionsj4cm2N0AqM50prwKtQD7atG2435SX8sxnRWWHbGJstUMeta } from "/tmp/build_0a61a028/pages/app/insiders/suggestions.vue?macro=true";
import { default as insiders0WlRe0bnNBFh8_45n_45Y6q4X9JLgrUotcFwMPwo0XJIKOAMeta } from "/tmp/build_0a61a028/pages/app/insiders.vue?macro=true";
import { default as messagesUOPX8Z59ArlwGpVLrdVWtnfvMFvbv_45Dum8VnI4FWsVUMeta } from "/tmp/build_0a61a028/pages/app/messages.vue?macro=true";
import { default as privacybXBc8iDqt6WPz9uqIicMz_45phyA8gk_OFTNwu_45sFy4FkMeta } from "/tmp/build_0a61a028/pages/main/privacy.vue?macro=true";
import { default as trainer3_RWzcddqJFBYKyKBRdb_pfKjSix3BBGYkBA78JQNPQMeta } from "/tmp/build_0a61a028/pages/admin/trainer.vue?macro=true";
import { default as index9_4sqgLagGR0fP564ixcxSSmzegGSlqTLfxGTDBnkVIMeta } from "/tmp/build_0a61a028/pages/app/community/index.vue?macro=true";
import { default as searchmmZJsD_htyTAcyUFg2IlL3tHBuPxLJD3FHbAkQ_45X96gMeta } from "/tmp/build_0a61a028/pages/app/community/search.vue?macro=true";
import { default as bestiesRFlcFpPnxgKs_Bb1bKSpGnE9FoE9FzGyHrr79fonCRYMeta } from "/tmp/build_0a61a028/pages/app/community/besties.vue?macro=true";
import { default as indexLITPa8ctpicn_qenY19Hj3aEuvr7xvr_Us5wpdirKEIMeta } from "/tmp/build_0a61a028/pages/app/community/[type]/index.vue?macro=true";
import { default as communityFOh2BwXz3kseoZxX2vU9TgLXvizW25qtO5D1apFcjN8Meta } from "/tmp/build_0a61a028/pages/app/community.vue?macro=true";
import { default as indexarWgSQaaKtmDbItZaNAG4JN_45Zy6U_45IytKzIRhHADTakMeta } from "/tmp/build_0a61a028/pages/app/quiz/[id]/index.vue?macro=true";
import { default as _91id_93tqH8vzDPOmzRYfm72BAeH6CfifqLclsMU7lYNguP5e4Meta } from "/tmp/build_0a61a028/pages/app/quiz/[id].vue?macro=true";
import { default as indexAVhlov3vjXwCNZW5rr5jg5d6Vpyoh5lvd7TD0alVmO0Meta } from "/tmp/build_0a61a028/pages/app/auth/index.vue?macro=true";
import { default as aboutL1iGX8vZqHKbmB5t5ty4tXxI9vPh55h02kcvlyzNTVQMeta } from "/tmp/build_0a61a028/pages/app/onboarding/about.vue?macro=true";
import { default as email48ggciKRKYwJHG0Cu4Cddi7E6T7_45t9pcJQ_45k2_4545oa0Meta } from "/tmp/build_0a61a028/pages/app/onboarding/email.vue?macro=true";
import { default as goalsUTvnXXSkwZVk2Cr4pq4_CuqUcH6z_4587x7DxJLzU_GRUMeta } from "/tmp/build_0a61a028/pages/app/onboarding/goals.vue?macro=true";
import { default as indexA6_CY2hZ1zs8Bn0X0FmYKjAjkDs_gql31Ylg4zbCXagMeta } from "/tmp/build_0a61a028/pages/app/onboarding/index.vue?macro=true";
import { default as phoneG09sEE_CKOhlqU1UnL4cc7JCAZPtii_45Wml0tvkVP11MMeta } from "/tmp/build_0a61a028/pages/app/onboarding/phone.vue?macro=true";
import { default as groupsUxl2MXGpCC2hDPJXVyCj8JkXT4skv5Y2ApRdLmkHWqkMeta } from "/tmp/build_0a61a028/pages/app/onboarding/groups.vue?macro=true";
import { default as searchQSiIH9fkQpk3R5nQh4ayQu3PTlhLwq1G61SHQCBYYawMeta } from "/tmp/build_0a61a028/pages/app/onboarding/search.vue?macro=true";
import { default as charter_r9tFAoll71gYDrmljejr4U0IBZD4we7XsQraVltkEQMeta } from "/tmp/build_0a61a028/pages/app/onboarding/charter.vue?macro=true";
import { default as loadingDwYN4tE6HvcyJYiM68887A2ZB5ENdkDOnAboZuYbgM4Meta } from "/tmp/build_0a61a028/pages/app/onboarding/loading.vue?macro=true";
import { default as profilet_uKCa8LUeBvmt7VNErtsyGiNGisipLIWwgJH05IZRoMeta } from "/tmp/build_0a61a028/pages/app/onboarding/profile.vue?macro=true";
import { default as identityt6hb0xRj76nBuNA9fS6Tf6Ox784GF_45qf4KhPvF2LH58Meta } from "/tmp/build_0a61a028/pages/app/onboarding/identity.vue?macro=true";
import { default as profilesfQf4lE_X_45Un7BRFmKxhC7z097D_IKOIqevOm74flWzkMeta } from "/tmp/build_0a61a028/pages/app/onboarding/profiles.vue?macro=true";
import { default as membershipcM4Dnk7kO9_O_45lGVzMC4TKR744O0Wtt6bpcUCnKRFY8Meta } from "/tmp/build_0a61a028/pages/app/onboarding/membership.vue?macro=true";
import { default as permissions9dgazD48HgJsQQcMvmVn4s4VQUwDJcksbh7ZOyuwn1cMeta } from "/tmp/build_0a61a028/pages/app/onboarding/permissions.vue?macro=true";
import { default as onboarding_45VXZo_dzKVjg9LGw1mE_45kRZDtHr71gtnbMltJ7fn2SgMeta } from "/tmp/build_0a61a028/pages/app/onboarding.vue?macro=true";
import { default as indexm_45pW3qrVOBFsuzAwmtxjM7mtjxJUKrN9_45VkLKOl_45TEMMeta } from "/tmp/build_0a61a028/pages/app/quiz/index.vue?macro=true";
import { default as investors2L_452CMPf_45PSgiNDvy_45_rr5Q16O_45Ng1fCvo0BVOtk_LAMeta } from "/tmp/build_0a61a028/pages/main/investors.vue?macro=true";
import { default as _91id_937CHhFFCyHycHVgThc1GBvl5WC9NUF8yY_z_l0Uv6T0AMeta } from "/tmp/build_0a61a028/pages/admin/blog/[id].vue?macro=true";
import { default as broadcastR26ZlzBxbqtX8K4ce9VeHXuMUQCSR71HxW6wV6EDEIkMeta } from "/tmp/build_0a61a028/pages/admin/broadcast.vue?macro=true";
import { default as deleten7t85cA5qS7Qld2UIAPCSHHCbbxFAucyO0zLkVXXfLcMeta } from "/tmp/build_0a61a028/pages/app/auth/delete.vue?macro=true";
import { default as logout3lB76qURHxvN_i8cHzMFXbuxzc2rAGEeQ_45AvZJ_jplsMeta } from "/tmp/build_0a61a028/pages/app/auth/logout.vue?macro=true";
import { default as indexdRU64_45JHoIu2mDBhEImTLaHS77_EYpfAJfFy8lPn2PQMeta } from "/tmp/build_0a61a028/pages/app/story/index.vue?macro=true";
import { default as indexJQC9FFrFIqQxas2ICoWOfyDppxDxV3nFiGk_R52odKQMeta } from "/tmp/build_0a61a028/pages/backstage/index.vue?macro=true";
import { default as index7l3lJWTMOWT7fjAOH7GTtLPZ8twCWHXmrGILGuTrUJYMeta } from "/tmp/build_0a61a028/pages/main/auth/index.vue?macro=true";
import { default as index27TslH7U9j3JEF7lKWdAQ52qbiNfMeF_45fBXo4RakUoIMeta } from "/tmp/build_0a61a028/pages/main/blog/index.vue?macro=true";
import { default as indexosGhYT50zjkEjeIlSYIhO1mpxDOBzX4kp3vds0pTLu0Meta } from "/tmp/build_0a61a028/pages/admin/auth/index.vue?macro=true";
import { default as indexleDbivdaR5hNgZ4xX5CcyvAtMGpgYvpgEknb11K0FYcMeta } from "/tmp/build_0a61a028/pages/admin/blog/index.vue?macro=true";
import { default as deleteTzByydVHcCvbVCRK_iCLntbHUx84H9eM51vKTQsJlB0Meta } from "/tmp/build_0a61a028/pages/main/auth/delete.vue?macro=true";
import { default as _91slug_93zBPOqkR6kG5yrUjb3aT2zQQwZ0Zf5odHZcTcJ3_45Go0QMeta } from "/tmp/build_0a61a028/pages/main/blog/[slug].vue?macro=true";
import { default as indexJQBHEzeRielxVileIexacPllFD1He15OEjSM5uVd3h0Meta } from "/tmp/build_0a61a028/pages/main/event/index.vue?macro=true";
import { default as _91token_93ygL4swN5lXe01e30QbsuFQZprGkKn_ozgxcV8kmmrVQMeta } from "/tmp/build_0a61a028/pages/payments/[token].vue?macro=true";
import { default as editcLmYUEz_1dCP_45JAyDqMe6ZdmWtnVpYyNAtK0Mg1jaGsMeta } from "/tmp/build_0a61a028/pages/app/events/[slug]/edit.vue?macro=true";
import { default as indexcN10lzpyLxocBkgSFlLzIi7Z41G0QW0MhOrlOqi4PPEMeta } from "/tmp/build_0a61a028/pages/app/events/[slug]/index.vue?macro=true";
import { default as _91slug_93io_45dOj2pCYwVF1yqunU2hlEZKMtMZ_45f_mwTcx_45OX_45EUMeta } from "/tmp/build_0a61a028/pages/app/events/[slug].vue?macro=true";
import { default as createllMW0YoK6vJl_45n3_45XThA99456Ra4N3zRrYqHt9lwfsYMeta } from "/tmp/build_0a61a028/pages/app/events/create.vue?macro=true";
import { default as listfcRuCR0mbKXM0SuZM6_45QyCl_ElPoRIFz1qPd0Jr3848Meta } from "/tmp/build_0a61a028/pages/app/partners/list.vue?macro=true";
import { default as _91slug_936PQxNNBt0aMRJ2ahSE68m1_451t3G947p6SSjCCxdLV8cMeta } from "/tmp/build_0a61a028/pages/main/event/[slug].vue?macro=true";
import { default as _91slug_93JlHlYP9NNyIJ5QkxKIAaQ5QCK0EcTzY4WVPECbxzzDgMeta } from "/tmp/build_0a61a028/pages/main/group/[slug].vue?macro=true";
import { default as _91slug_93A4GXFdEC1rASXstGim6Vd6oh5p7vJTMPobVbT0NzwiQMeta } from "/tmp/build_0a61a028/pages/main/place/[slug].vue?macro=true";
import { default as _91city_93ev2vccxO240ii22tRPDRM985Dn3tVxmpfYckJOoTSccMeta } from "/tmp/build_0a61a028/pages/main/cities/[city].vue?macro=true";
import { default as _91slug_93xtgzVUwInl4uPs2o_45_mfFbIWYOnZVYY257A0jNInMQkMeta } from "/tmp/build_0a61a028/pages/main/invite/[slug].vue?macro=true";
import { default as organizationsvZ063Es0Ex52L6wJo3I1_45_i2zAqtLnQcs7FcOv7RXL8Meta } from "/tmp/build_0a61a028/pages/admin/organizations.vue?macro=true";
import { default as index7HUF6IW6_45cOiMbhrhYRPSFodz1Ziq_5KnWrBpoGNuzIMeta } from "/tmp/build_0a61a028/pages/admin/reports/index.vue?macro=true";
import { default as eventspTX0oP_456oLddY83yelWVdns2S7AZcBhcmOV17EpbtfcMeta } from "/tmp/build_0a61a028/pages/admin/reports/events.vue?macro=true";
import { default as preferencesEa5uQjF1QfjJ4BQnUKBP3LSwcCLZiy_iIn5ZzpuFjasMeta } from "/tmp/build_0a61a028/pages/app/auth/preferences.vue?macro=true";
import { default as loginBImn8vS5FvKztDPuzduL_45ci8CcfOZoFQ938nKEH3TtMMeta } from "/tmp/build_0a61a028/pages/backstage/auth/login.vue?macro=true";
import { default as _91id_93HWnO60Uyf8Do24mHit2jqRHjQOIh_IFRL8QuPQTI2FMMeta } from "/tmp/build_0a61a028/pages/app/conversation/[id].vue?macro=true";
import { default as logoutkZdCLvCE0ESjoWzdUuzuxvzPgy4OMlusjmILI2t9RxsMeta } from "/tmp/build_0a61a028/pages/backstage/auth/logout.vue?macro=true";
import { default as preferencesfQMs9hrgQg6WEL_45m7CUAN7kADWEJPhxaTGoHRjdbWoUMeta } from "/tmp/build_0a61a028/pages/main/auth/preferences.vue?macro=true";
import { default as list_RLY2tXCEC8cSDjAvxosg7u64_grf_45buLJmZLSGohooMeta } from "/tmp/build_0a61a028/pages/app/organizations/list.vue?macro=true";
import { default as _91token_93RcfejLNfiNrIJkajYJ2suwlCCKvEyS6niF7ELEYXemUMeta } from "/tmp/build_0a61a028/pages/app/auth/verify/[token].vue?macro=true";
import { default as register3FYNKbyaGJHKG_3qp1vi9qMIESyj7hTVATun2w6Z9N8Meta } from "/tmp/build_0a61a028/pages/backstage/auth/register.vue?macro=true";
import { default as _91code_93mC4YMaEWxe7SmMeIe0W3H1XwnnPdqz2uroujmPxWlGwMeta } from "/tmp/build_0a61a028/pages/backstage/invite/[code].vue?macro=true";
import { default as discord2lWB8SEekGxyPSw_45B95tebFsSazVY5tK6uLqB3HjCvUMeta } from "/tmp/build_0a61a028/pages/app/integrations/discord.vue?macro=true";
import { default as index03Jlxl_45mJ_45fi1bbU5e8XdRX23r7YoHvSA8JdpkRDFTQMeta } from "/tmp/build_0a61a028/pages/backstage/dashboard/index.vue?macro=true";
import { default as questions_45frequentes9vymOpq3o8z_OAlJdgjrlrJTDEwl28wO2ThmH44WpiMMeta } from "/tmp/build_0a61a028/pages/main/questions-frequentes.vue?macro=true";
import { default as discord_45authMxfUy38t3Rxz77ndAMGysKTbLYa1aX0mCbHtGqiI2VkMeta } from "/tmp/build_0a61a028/pages/app/integrations/discord-auth.vue?macro=true";
import { default as subscribeiB8LQv6KMup41d05bYH7Ndj2wf87gLf_UHvuJDyHA5gMeta } from "/tmp/build_0a61a028/pages/backstage/dashboard/subscribe.vue?macro=true";
import { default as indexveiWDg6nVHqnrJg5tz1j5ejpil9G_45v1aLtnvdY2XDroMeta } from "/tmp/build_0a61a028/pages/backstage/dashboard/events/index.vue?macro=true";
import { default as indexmcHKoWfcLdYrKenrCeAdbpWawaNcTPWl5EzMojgbfVQMeta } from "/tmp/build_0a61a028/pages/backstage/dashboard/places/index.vue?macro=true";
import { default as index_p27DvCtgLa0zk4A66fA_453ZJDkFiGNRBAB6DUqd_45QmwMeta } from "/tmp/build_0a61a028/pages/backstage/dashboard/events/[slug]/edit/index.vue?macro=true";
import { default as detailsVxUM5C8Rvo_Q8YTrFMB5kPZGbLxy6AR5FCIJKtmqfBkMeta } from "/tmp/build_0a61a028/pages/backstage/dashboard/events/[slug]/edit/details.vue?macro=true";
import { default as advanced_45FfNs7KDkuuKmJNgJvU0jcIgHkyYhexiOMgNEN7eeEEMeta } from "/tmp/build_0a61a028/pages/backstage/dashboard/events/[slug]/edit/advanced.vue?macro=true";
import { default as attendees4h0IVtUUvG6j_45TVDPRUQGPsBZG_dU8WApyyd0fNNcLcMeta } from "/tmp/build_0a61a028/pages/backstage/dashboard/events/[slug]/edit/attendees.vue?macro=true";
import { default as edituu63zAcg5ACHUtUt5cMqk2mKZ3sYB2jAzFhCGdhUfk0Meta } from "/tmp/build_0a61a028/pages/backstage/dashboard/events/[slug]/edit.vue?macro=true";
import { default as indexHWP89ql_oJVscF_LXviFEzKDkj9gPabPFSDrOQvEOvkMeta } from "/tmp/build_0a61a028/pages/backstage/dashboard/events/[slug]/index.vue?macro=true";
import { default as attendeesGZF4Z0Fb_45nWfs0iB7sgduGduFqkcDqChWrU_45dILz8o4Meta } from "/tmp/build_0a61a028/pages/backstage/dashboard/events/[slug]/attendees.vue?macro=true";
import { default as _91slug_93SWL0VfeyeEaStJBdrlElD5J7xFfSIz1fQ99JeCkrRhYMeta } from "/tmp/build_0a61a028/pages/backstage/dashboard/events/[slug].vue?macro=true";
import { default as createGKfVvnWmvD6X7gxUJs848sWhuSl3yc4fQLXPrBQEiCAMeta } from "/tmp/build_0a61a028/pages/backstage/dashboard/events/create.vue?macro=true";
import { default as indexnlPeszRZe47oz2j_LN_QAcSzw9lmJ8nubpETaVBlrCYMeta } from "/tmp/build_0a61a028/pages/backstage/dashboard/settings/index.vue?macro=true";
import { default as indexZX5BnaFLB7RmR8B4vmlEPeg5gfeFTS8GqsbvmATR_rYMeta } from "/tmp/build_0a61a028/pages/backstage/dashboard/organization/index.vue?macro=true";
import { default as component_45stubGxcEIpNqxOqbkrkKDeWWYIIjPdt9fOvIzSBPlJmavLMMeta } from "/tmp/build_0a61a028/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubGxcEIpNqxOqbkrkKDeWWYIIjPdt9fOvIzSBPlJmavLM } from "/tmp/build_0a61a028/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: meO2RrXpyHyrhjjZEkcNsor9ms1EkprZwc4clRhkDG44oMeta?.name,
    path: "/app/me",
    meta: meO2RrXpyHyrhjjZEkcNsor9ms1EkprZwc4clRhkDG44oMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/me.vue"),
    children: [
  {
    name: "app-me",
    path: "",
    component: () => import("/tmp/build_0a61a028/pages/app/me/index.vue")
  }
]
  },
  {
    name: "app-map",
    path: "/app/map",
    meta: { ...(mape_45QuTv0oK7CTH_85uMCjq7LuxdIIun_45_8GJlKVGzOu8Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/map.vue")
  },
  {
    name: feediZgjFaybYhqmNniNegCNZESOwMZ7F125_45tHdFT8LiIAMeta?.name,
    path: "/app/feed",
    meta: { ...(feediZgjFaybYhqmNniNegCNZESOwMZ7F125_45tHdFT8LiIAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/feed.vue"),
    children: [
  {
    name: "app-feed-post",
    path: "post",
    meta: postf8SjGEs2kfGQXbReNpHNrFotkNCKu7A8jzx0iQbMZPAMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/feed/post.vue")
  },
  {
    name: "app-feed",
    path: "",
    meta: indexArLjz894MjfycN0BkkDluJHdcg5lAzfkionzIfMClS8Meta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/feed/index.vue")
  },
  {
    name: "app-feed-type",
    path: ":type()",
    meta: _91type_93spOhCcl2HUIWjkMD_JFH_jxcLbJtramrLk97tg7z2iQMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/feed/[type].vue")
  }
]
  },
  {
    name: "app",
    path: "/app",
    meta: { ...(index02RcnmdFtabmC11MzSHLTzLIchMU7JYnQFY12fY_45jTkMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/index.vue")
  },
  {
    name: "main-eula",
    path: "/main/eula",
    meta: eula6Plna0PMyVf1vB_45hR0_45QRp7NJxhz4iTJET_45ZHPNzfokMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/main/eula.vue")
  },
  {
    name: "admin-quiz",
    path: "/admin/quiz",
    meta: { ...(quizh11l4Q8MY_7XLzkVYASjOuIhSku4Ghy7zuOFVwcvi74Meta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_0a61a028/pages/admin/quiz.vue")
  },
  {
    name: groupsC_On8YvARcRUn8uUArADWx0GBA9VjwMS9EBNNorXQQYMeta?.name,
    path: "/app/groups",
    meta: { ...(groupsC_On8YvARcRUn8uUArADWx0GBA9VjwMS9EBNNorXQQYMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/groups.vue"),
    children: [
  {
    name: "app-groups",
    path: "",
    component: () => import("/tmp/build_0a61a028/pages/app/groups/index.vue")
  },
  {
    name: _91slug_93hmlB1PsmJ30xMEi04FMivuMW0pQldBNTrovLO_45XUvk0Meta?.name,
    path: ":slug()",
    meta: _91slug_93hmlB1PsmJ30xMEi04FMivuMW0pQldBNTrovLO_45XUvk0Meta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/groups/[slug].vue"),
    children: [
  {
    name: "app-groups-slug-edit",
    path: "edit",
    component: () => import("/tmp/build_0a61a028/pages/app/groups/[slug]/edit.vue")
  },
  {
    name: "app-groups-slug-about",
    path: "about",
    component: () => import("/tmp/build_0a61a028/pages/app/groups/[slug]/about.vue")
  },
  {
    name: "app-groups-slug",
    path: "",
    component: () => import("/tmp/build_0a61a028/pages/app/groups/[slug]/index.vue")
  },
  {
    name: "app-groups-slug-events",
    path: "events",
    component: () => import("/tmp/build_0a61a028/pages/app/groups/[slug]/events.vue")
  },
  {
    name: "app-groups-slug-members",
    path: "members",
    component: () => import("/tmp/build_0a61a028/pages/app/groups/[slug]/members.vue")
  },
  {
    name: "app-groups-slug-conversations",
    path: "conversations",
    component: () => import("/tmp/build_0a61a028/pages/app/groups/[slug]/conversations.vue")
  }
]
  },
  {
    name: "app-groups-create",
    path: "create",
    meta: creategOP6zyeOjJ_45_ZxhJLR8C9P5uGoqp4PKNBcUP91EmmT0Meta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/groups/create.vue")
  }
]
  },
  {
    name: paramsbi5C3bUf14_aVGxg6Kh9fm8rkJ2stKs11aEAqJFQn_45YMeta?.name,
    path: "/app/params",
    meta: { ...(paramsbi5C3bUf14_aVGxg6Kh9fm8rkJ2stKs11aEAqJFQn_45YMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/params.vue"),
    children: [
  {
    name: "app-params",
    path: "",
    meta: { ...(indexB_9nPvtQ74pTEBTuTftg_45d5mci_45gKqIoJi29F4KARb8Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/params/index.vue")
  },
  {
    name: "app-params-account",
    path: "account",
    meta: { ...(accountU3qvXnW7NU26yZy_6D4xumR7llU4f0njNDEyxvHi_BEMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/params/account.vue")
  },
  {
    name: "app-params-transactions",
    path: "transactions",
    meta: { ...(transactionsJyU9ImYi7K73k8U_45TEnFonda_Bpj5W8X4dODLOjMyGIMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/params/transactions.vue")
  }
]
  },
  {
    name: "main",
    path: "/main",
    meta: indexczvp0mHpM2HTkNFCw8sojbQyUv5h0HTzDFW_TVGj9IoMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/main/index.vue")
  },
  {
    name: "main-press",
    path: "/main/press",
    meta: pressme6ddzWe9BwKaPQzWW_V7vsxHCmhau7gTD2s9FHHfvoMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/main/press.vue")
  },
  {
    name: "admin-codes",
    path: "/admin/codes",
    meta: { ...(codesE3PgMcRoJUxi_OCEDjzy1Qf9H9_45SiqOfq04tzed_45c0cMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_0a61a028/pages/admin/codes.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexAD0yf4VOgOylDSAkBmaGp2MidmlRlXb7F_45YF9s6Nd08Meta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_0a61a028/pages/admin/index.vue")
  },
  {
    name: hangoutdz3LpIaIKQ5e_45rdpuPyv_OCzMh3idUtSI_45JF3ooNZDMMeta?.name,
    path: "/app/hangout",
    meta: { ...(hangoutdz3LpIaIKQ5e_45rdpuPyv_OCzMh3idUtSI_45JF3ooNZDMMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/hangout.vue"),
    children: [
  {
    name: "app-hangout",
    path: "",
    meta: index3OCLeuERCJb8c4P97b3BQu7nexWedXcqJXFj5iSSYAgMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/hangout/index.vue")
  },
  {
    name: "app-hangout-agenda",
    path: "agenda",
    meta: { ...(agendaBpbhSa3MFIONcMcXBJEX7S_4551U3IiylD_jqY_kZu5SkMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/hangout/agenda.vue")
  },
  {
    name: "app-hangout-meetups",
    path: "meetups",
    meta: meetupsPsdenkHW2rQQIgZnc0thannZ02YIUqQGkIDpqCClK3gMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/hangout/meetups.vue")
  },
  {
    name: "app-hangout-organize",
    path: "organize",
    meta: { ...(organizepOhysMYRNwtM_45QdtvitXkFAr9aWIIs7FHvhFETihj6kMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/hangout/organize.vue")
  }
]
  },
  {
    name: "main-charte",
    path: "/main/charte",
    meta: charteXba_y2Hmmg9DTPOrKC2A8AexcEB6Cpn8O_vbjAo6R6gMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/main/charte.vue")
  },
  {
    name: "main-france",
    path: "/main/france",
    meta: francecUocFvxboqrzlRq0kg0Ii9AyFlLcaybsMW278HDwp9oMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/main/france.vue")
  },
  {
    name: "admin-themes",
    path: "/admin/themes",
    meta: { ...(themesVVlepjwiVhM2mtK46_45W3K_N8rWASURpsz_9_X_45PQ1XMMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_0a61a028/pages/admin/themes.vue")
  },
  {
    name: insiders0WlRe0bnNBFh8_45n_45Y6q4X9JLgrUotcFwMPwo0XJIKOAMeta?.name,
    path: "/app/insiders",
    meta: { ...(insiders0WlRe0bnNBFh8_45n_45Y6q4X9JLgrUotcFwMPwo0XJIKOAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/insiders.vue"),
    children: [
  {
    name: "app-insiders",
    path: "",
    component: () => import("/tmp/build_0a61a028/pages/app/insiders/index.vue")
  },
  {
    name: "app-insiders-suggestions",
    path: "suggestions",
    meta: suggestionsj4cm2N0AqM50prwKtQD7atG2435SX8sxnRWWHbGJstUMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/insiders/suggestions.vue")
  }
]
  },
  {
    name: "app-messages",
    path: "/app/messages",
    meta: { ...(messagesUOPX8Z59ArlwGpVLrdVWtnfvMFvbv_45Dum8VnI4FWsVUMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/messages.vue")
  },
  {
    name: "main-privacy",
    path: "/main/privacy",
    meta: privacybXBc8iDqt6WPz9uqIicMz_45phyA8gk_OFTNwu_45sFy4FkMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/main/privacy.vue")
  },
  {
    name: "admin-trainer",
    path: "/admin/trainer",
    meta: { ...(trainer3_RWzcddqJFBYKyKBRdb_pfKjSix3BBGYkBA78JQNPQMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_0a61a028/pages/admin/trainer.vue")
  },
  {
    name: communityFOh2BwXz3kseoZxX2vU9TgLXvizW25qtO5D1apFcjN8Meta?.name,
    path: "/app/community",
    meta: { ...(communityFOh2BwXz3kseoZxX2vU9TgLXvizW25qtO5D1apFcjN8Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/community.vue"),
    children: [
  {
    name: "app-community",
    path: "",
    meta: index9_4sqgLagGR0fP564ixcxSSmzegGSlqTLfxGTDBnkVIMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/community/index.vue")
  },
  {
    name: "app-community-search",
    path: "search",
    meta: searchmmZJsD_htyTAcyUFg2IlL3tHBuPxLJD3FHbAkQ_45X96gMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/community/search.vue")
  },
  {
    name: "app-community-besties",
    path: "besties",
    component: () => import("/tmp/build_0a61a028/pages/app/community/besties.vue")
  },
  {
    name: "app-community-type",
    path: ":type()",
    meta: { ...(indexLITPa8ctpicn_qenY19Hj3aEuvr7xvr_Us5wpdirKEIMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/community/[type]/index.vue")
  }
]
  },
  {
    name: _91id_93tqH8vzDPOmzRYfm72BAeH6CfifqLclsMU7lYNguP5e4Meta?.name,
    path: "/app/quiz/:id()",
    meta: { ...(_91id_93tqH8vzDPOmzRYfm72BAeH6CfifqLclsMU7lYNguP5e4Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/quiz/[id].vue"),
    children: [
  {
    name: "app-quiz-id",
    path: "",
    component: () => import("/tmp/build_0a61a028/pages/app/quiz/[id]/index.vue")
  }
]
  },
  {
    name: "app-auth",
    path: "/app/auth",
    meta: { ...(indexAVhlov3vjXwCNZW5rr5jg5d6Vpyoh5lvd7TD0alVmO0Meta || {}), ...{"middleware":["is-not-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/auth/index.vue")
  },
  {
    name: onboarding_45VXZo_dzKVjg9LGw1mE_45kRZDtHr71gtnbMltJ7fn2SgMeta?.name,
    path: "/app/onboarding",
    meta: { ...(onboarding_45VXZo_dzKVjg9LGw1mE_45kRZDtHr71gtnbMltJ7fn2SgMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/onboarding.vue"),
    children: [
  {
    name: "app-onboarding-about",
    path: "about",
    component: () => import("/tmp/build_0a61a028/pages/app/onboarding/about.vue")
  },
  {
    name: "app-onboarding-email",
    path: "email",
    component: () => import("/tmp/build_0a61a028/pages/app/onboarding/email.vue")
  },
  {
    name: "app-onboarding-goals",
    path: "goals",
    component: () => import("/tmp/build_0a61a028/pages/app/onboarding/goals.vue")
  },
  {
    name: "app-onboarding",
    path: "",
    meta: indexA6_CY2hZ1zs8Bn0X0FmYKjAjkDs_gql31Ylg4zbCXagMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/onboarding/index.vue")
  },
  {
    name: "app-onboarding-phone",
    path: "phone",
    component: () => import("/tmp/build_0a61a028/pages/app/onboarding/phone.vue")
  },
  {
    name: "app-onboarding-groups",
    path: "groups",
    component: () => import("/tmp/build_0a61a028/pages/app/onboarding/groups.vue")
  },
  {
    name: "app-onboarding-search",
    path: "search",
    component: () => import("/tmp/build_0a61a028/pages/app/onboarding/search.vue")
  },
  {
    name: "app-onboarding-charter",
    path: "charter",
    component: () => import("/tmp/build_0a61a028/pages/app/onboarding/charter.vue")
  },
  {
    name: "app-onboarding-loading",
    path: "loading",
    component: () => import("/tmp/build_0a61a028/pages/app/onboarding/loading.vue")
  },
  {
    name: "app-onboarding-profile",
    path: "profile",
    component: () => import("/tmp/build_0a61a028/pages/app/onboarding/profile.vue")
  },
  {
    name: "app-onboarding-identity",
    path: "identity",
    component: () => import("/tmp/build_0a61a028/pages/app/onboarding/identity.vue")
  },
  {
    name: "app-onboarding-profiles",
    path: "profiles",
    component: () => import("/tmp/build_0a61a028/pages/app/onboarding/profiles.vue")
  },
  {
    name: "app-onboarding-membership",
    path: "membership",
    component: () => import("/tmp/build_0a61a028/pages/app/onboarding/membership.vue")
  },
  {
    name: "app-onboarding-permissions",
    path: "permissions",
    component: () => import("/tmp/build_0a61a028/pages/app/onboarding/permissions.vue")
  }
]
  },
  {
    name: "app-quiz",
    path: "/app/quiz",
    meta: { ...(indexm_45pW3qrVOBFsuzAwmtxjM7mtjxJUKrN9_45VkLKOl_45TEMMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/quiz/index.vue")
  },
  {
    name: "main-investors",
    path: "/main/investors",
    meta: investors2L_452CMPf_45PSgiNDvy_45_rr5Q16O_45Ng1fCvo0BVOtk_LAMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/main/investors.vue")
  },
  {
    name: "admin-blog-id",
    path: "/admin/blog/:id()",
    meta: { ...(_91id_937CHhFFCyHycHVgThc1GBvl5WC9NUF8yY_z_l0Uv6T0AMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_0a61a028/pages/admin/blog/[id].vue")
  },
  {
    name: "admin-broadcast",
    path: "/admin/broadcast",
    meta: { ...(broadcastR26ZlzBxbqtX8K4ce9VeHXuMUQCSR71HxW6wV6EDEIkMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_0a61a028/pages/admin/broadcast.vue")
  },
  {
    name: "app-auth-delete",
    path: "/app/auth/delete",
    meta: deleten7t85cA5qS7Qld2UIAPCSHHCbbxFAucyO0zLkVXXfLcMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/auth/delete.vue")
  },
  {
    name: "app-auth-logout",
    path: "/app/auth/logout",
    meta: logout3lB76qURHxvN_i8cHzMFXbuxzc2rAGEeQ_45AvZJ_jplsMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/auth/logout.vue")
  },
  {
    name: "app-story",
    path: "/app/story",
    meta: { ...(indexdRU64_45JHoIu2mDBhEImTLaHS77_EYpfAJfFy8lPn2PQMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/story/index.vue")
  },
  {
    name: "backstage",
    path: "/backstage",
    meta: { ...(indexJQC9FFrFIqQxas2ICoWOfyDppxDxV3nFiGk_R52odKQMeta || {}), ...{"middleware":["backstage-auth"]} },
    component: () => import("/tmp/build_0a61a028/pages/backstage/index.vue")
  },
  {
    name: "main-auth",
    path: "/main/auth",
    component: () => import("/tmp/build_0a61a028/pages/main/auth/index.vue")
  },
  {
    name: "main-blog",
    path: "/main/blog",
    meta: index27TslH7U9j3JEF7lKWdAQ52qbiNfMeF_45fBXo4RakUoIMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/main/blog/index.vue")
  },
  {
    name: "admin-auth",
    path: "/admin/auth",
    meta: indexosGhYT50zjkEjeIlSYIhO1mpxDOBzX4kp3vds0pTLu0Meta || {},
    component: () => import("/tmp/build_0a61a028/pages/admin/auth/index.vue")
  },
  {
    name: "admin-blog",
    path: "/admin/blog",
    meta: { ...(indexleDbivdaR5hNgZ4xX5CcyvAtMGpgYvpgEknb11K0FYcMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_0a61a028/pages/admin/blog/index.vue")
  },
  {
    name: "main-auth-delete",
    path: "/main/auth/delete",
    component: () => import("/tmp/build_0a61a028/pages/main/auth/delete.vue")
  },
  {
    name: "main-blog-slug",
    path: "/main/blog/:slug()",
    meta: _91slug_93zBPOqkR6kG5yrUjb3aT2zQQwZ0Zf5odHZcTcJ3_45Go0QMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/main/blog/[slug].vue")
  },
  {
    name: "main-event",
    path: "/main/event",
    meta: indexJQBHEzeRielxVileIexacPllFD1He15OEjSM5uVd3h0Meta || {},
    component: () => import("/tmp/build_0a61a028/pages/main/event/index.vue")
  },
  {
    name: "payments-token",
    path: "/payments/:token()",
    meta: _91token_93ygL4swN5lXe01e30QbsuFQZprGkKn_ozgxcV8kmmrVQMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/payments/[token].vue")
  },
  {
    name: _91slug_93io_45dOj2pCYwVF1yqunU2hlEZKMtMZ_45f_mwTcx_45OX_45EUMeta?.name,
    path: "/app/events/:slug()",
    meta: { ...(_91slug_93io_45dOj2pCYwVF1yqunU2hlEZKMtMZ_45f_mwTcx_45OX_45EUMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/events/[slug].vue"),
    children: [
  {
    name: "app-events-slug-edit",
    path: "edit",
    meta: editcLmYUEz_1dCP_45JAyDqMe6ZdmWtnVpYyNAtK0Mg1jaGsMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/events/[slug]/edit.vue")
  },
  {
    name: "app-events-slug",
    path: "",
    component: () => import("/tmp/build_0a61a028/pages/app/events/[slug]/index.vue")
  }
]
  },
  {
    name: "app-events-create",
    path: "/app/events/create",
    meta: { ...(createllMW0YoK6vJl_45n3_45XThA99456Ra4N3zRrYqHt9lwfsYMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/events/create.vue")
  },
  {
    name: "app-partners-list",
    path: "/app/partners/list",
    meta: { ...(listfcRuCR0mbKXM0SuZM6_45QyCl_ElPoRIFz1qPd0Jr3848Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/partners/list.vue")
  },
  {
    name: "main-event-slug",
    path: "/main/event/:slug()",
    meta: _91slug_936PQxNNBt0aMRJ2ahSE68m1_451t3G947p6SSjCCxdLV8cMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/main/event/[slug].vue")
  },
  {
    name: "main-group-slug",
    path: "/main/group/:slug()",
    meta: _91slug_93JlHlYP9NNyIJ5QkxKIAaQ5QCK0EcTzY4WVPECbxzzDgMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/main/group/[slug].vue")
  },
  {
    name: "main-place-slug",
    path: "/main/place/:slug()",
    meta: _91slug_93A4GXFdEC1rASXstGim6Vd6oh5p7vJTMPobVbT0NzwiQMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/main/place/[slug].vue")
  },
  {
    name: "main-cities-city",
    path: "/main/cities/:city()",
    meta: _91city_93ev2vccxO240ii22tRPDRM985Dn3tVxmpfYckJOoTSccMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/main/cities/[city].vue")
  },
  {
    name: "main-invite-slug",
    path: "/main/invite/:slug()",
    component: () => import("/tmp/build_0a61a028/pages/main/invite/[slug].vue")
  },
  {
    name: "admin-organizations",
    path: "/admin/organizations",
    meta: { ...(organizationsvZ063Es0Ex52L6wJo3I1_45_i2zAqtLnQcs7FcOv7RXL8Meta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_0a61a028/pages/admin/organizations.vue")
  },
  {
    name: "admin-reports",
    path: "/admin/reports",
    meta: { ...(index7HUF6IW6_45cOiMbhrhYRPSFodz1Ziq_5KnWrBpoGNuzIMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_0a61a028/pages/admin/reports/index.vue")
  },
  {
    name: "admin-reports-events",
    path: "/admin/reports/events",
    meta: { ...(eventspTX0oP_456oLddY83yelWVdns2S7AZcBhcmOV17EpbtfcMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_0a61a028/pages/admin/reports/events.vue")
  },
  {
    name: "app-auth-preferences",
    path: "/app/auth/preferences",
    meta: preferencesEa5uQjF1QfjJ4BQnUKBP3LSwcCLZiy_iIn5ZzpuFjasMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/auth/preferences.vue")
  },
  {
    name: "backstage-auth-login",
    path: "/backstage/auth/login",
    meta: loginBImn8vS5FvKztDPuzduL_45ci8CcfOZoFQ938nKEH3TtMMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/backstage/auth/login.vue")
  },
  {
    name: "app-conversation-id",
    path: "/app/conversation/:id()",
    meta: { ...(_91id_93HWnO60Uyf8Do24mHit2jqRHjQOIh_IFRL8QuPQTI2FMMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/conversation/[id].vue")
  },
  {
    name: "backstage-auth-logout",
    path: "/backstage/auth/logout",
    meta: logoutkZdCLvCE0ESjoWzdUuzuxvzPgy4OMlusjmILI2t9RxsMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/backstage/auth/logout.vue")
  },
  {
    name: "main-auth-preferences",
    path: "/main/auth/preferences",
    component: () => import("/tmp/build_0a61a028/pages/main/auth/preferences.vue")
  },
  {
    name: "app-organizations-list",
    path: "/app/organizations/list",
    meta: { ...(list_RLY2tXCEC8cSDjAvxosg7u64_grf_45buLJmZLSGohooMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/app/organizations/list.vue")
  },
  {
    name: "app-auth-verify-token",
    path: "/app/auth/verify/:token()",
    meta: _91token_93RcfejLNfiNrIJkajYJ2suwlCCKvEyS6niF7ELEYXemUMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/auth/verify/[token].vue")
  },
  {
    name: "backstage-auth-register",
    path: "/backstage/auth/register",
    meta: register3FYNKbyaGJHKG_3qp1vi9qMIESyj7hTVATun2w6Z9N8Meta || {},
    component: () => import("/tmp/build_0a61a028/pages/backstage/auth/register.vue")
  },
  {
    name: "backstage-invite-code",
    path: "/backstage/invite/:code()",
    meta: _91code_93mC4YMaEWxe7SmMeIe0W3H1XwnnPdqz2uroujmPxWlGwMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/backstage/invite/[code].vue")
  },
  {
    name: "app-integrations-discord",
    path: "/app/integrations/discord",
    meta: discord2lWB8SEekGxyPSw_45B95tebFsSazVY5tK6uLqB3HjCvUMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/integrations/discord.vue")
  },
  {
    name: "backstage-dashboard",
    path: "/backstage/dashboard",
    meta: { ...(index03Jlxl_45mJ_45fi1bbU5e8XdRX23r7YoHvSA8JdpkRDFTQMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/backstage/dashboard/index.vue")
  },
  {
    name: "main-questions-frequentes",
    path: "/main/questions-frequentes",
    meta: questions_45frequentes9vymOpq3o8z_OAlJdgjrlrJTDEwl28wO2ThmH44WpiMMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/main/questions-frequentes.vue")
  },
  {
    name: "app-integrations-discord-auth",
    path: "/app/integrations/discord-auth",
    meta: discord_45authMxfUy38t3Rxz77ndAMGysKTbLYa1aX0mCbHtGqiI2VkMeta || {},
    component: () => import("/tmp/build_0a61a028/pages/app/integrations/discord-auth.vue")
  },
  {
    name: "backstage-dashboard-subscribe",
    path: "/backstage/dashboard/subscribe",
    meta: { ...(subscribeiB8LQv6KMup41d05bYH7Ndj2wf87gLf_UHvuJDyHA5gMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/backstage/dashboard/subscribe.vue")
  },
  {
    name: "backstage-dashboard-events",
    path: "/backstage/dashboard/events",
    meta: { ...(indexveiWDg6nVHqnrJg5tz1j5ejpil9G_45v1aLtnvdY2XDroMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/backstage/dashboard/events/index.vue")
  },
  {
    name: "backstage-dashboard-places",
    path: "/backstage/dashboard/places",
    meta: { ...(indexmcHKoWfcLdYrKenrCeAdbpWawaNcTPWl5EzMojgbfVQMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/backstage/dashboard/places/index.vue")
  },
  {
    name: _91slug_93SWL0VfeyeEaStJBdrlElD5J7xFfSIz1fQ99JeCkrRhYMeta?.name,
    path: "/backstage/dashboard/events/:slug()",
    component: () => import("/tmp/build_0a61a028/pages/backstage/dashboard/events/[slug].vue"),
    children: [
  {
    name: edituu63zAcg5ACHUtUt5cMqk2mKZ3sYB2jAzFhCGdhUfk0Meta?.name,
    path: "edit",
    meta: { ...(edituu63zAcg5ACHUtUt5cMqk2mKZ3sYB2jAzFhCGdhUfk0Meta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/backstage/dashboard/events/[slug]/edit.vue"),
    children: [
  {
    name: "backstage-dashboard-events-slug-edit",
    path: "",
    component: () => import("/tmp/build_0a61a028/pages/backstage/dashboard/events/[slug]/edit/index.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-details",
    path: "details",
    component: () => import("/tmp/build_0a61a028/pages/backstage/dashboard/events/[slug]/edit/details.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-advanced",
    path: "advanced",
    component: () => import("/tmp/build_0a61a028/pages/backstage/dashboard/events/[slug]/edit/advanced.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-attendees",
    path: "attendees",
    component: () => import("/tmp/build_0a61a028/pages/backstage/dashboard/events/[slug]/edit/attendees.vue")
  }
]
  },
  {
    name: "backstage-dashboard-events-slug",
    path: "",
    meta: { ...(indexHWP89ql_oJVscF_LXviFEzKDkj9gPabPFSDrOQvEOvkMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/backstage/dashboard/events/[slug]/index.vue")
  },
  {
    name: "backstage-dashboard-events-slug-attendees",
    path: "attendees",
    meta: { ...(attendeesGZF4Z0Fb_45nWfs0iB7sgduGduFqkcDqChWrU_45dILz8o4Meta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/backstage/dashboard/events/[slug]/attendees.vue")
  }
]
  },
  {
    name: "backstage-dashboard-events-create",
    path: "/backstage/dashboard/events/create",
    meta: { ...(createGKfVvnWmvD6X7gxUJs848sWhuSl3yc4fQLXPrBQEiCAMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/backstage/dashboard/events/create.vue")
  },
  {
    name: "backstage-dashboard-settings",
    path: "/backstage/dashboard/settings",
    meta: { ...(indexnlPeszRZe47oz2j_LN_QAcSzw9lmJ8nubpETaVBlrCYMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/backstage/dashboard/settings/index.vue")
  },
  {
    name: "backstage-dashboard-organization",
    path: "/backstage/dashboard/organization",
    meta: { ...(indexZX5BnaFLB7RmR8B4vmlEPeg5gfeFTS8GqsbvmATR_rYMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_0a61a028/pages/backstage/dashboard/organization/index.vue")
  },
  {
    name: component_45stubGxcEIpNqxOqbkrkKDeWWYIIjPdt9fOvIzSBPlJmavLMMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubGxcEIpNqxOqbkrkKDeWWYIIjPdt9fOvIzSBPlJmavLM
  }
]